import React, { useState, useEffect, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import PQLoans from './PQLoans';
import PQOpps from './PQOpps';


const LoansPreQual = ( { settings } ) => {
    const [ pageType, setPageType ] = useState( 'opps' );
    
        useEffect( () => {
            if ( settings?.prequals?.pageType === 'loans' ) {
                setPageType( 'loans' );
            }
        }, [ settings ] );
        
        return (
            <>
                { pageType === 'loans' ? <PQLoans /> : <PQOpps /> }
            </>
        )
    }
    
const mapProps = ( state ) => ( {
    settings: state.user.meta.settings
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LoansPreQual );